import './plugins'
import vuetify from './plugins/vuetify'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import VueCookies from 'vue-cookies'
import Vue2Editor from 'vue2-editor'
import VueSanitize from 'vue-sanitize'

import jQuery from 'jquery'
import { get, capitalize } from 'lodash'

global.jQuery = jQuery

sync(store, router)

Vue.use(VueCookies)
Vue.use(Vue2Editor)
Vue.use(VueSanitize, {
  allowedTags: [
    'p', 'br', 'div', 'span', 'a',
    'b', 'strong', 'i', 'em', 'u', 's',
    'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'blockquote', 'code', 'pre', 'hr',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'img',
  ],
  allowedAttributes: {
    '*': [ 'class', 'style', 'id', 'title', 'data-*', 'align', 'dir' ],
    a: [ 'href', 'name', 'target', 'rel' ],
    img: [ 'src', 'alt', 'width', 'height', 'loading' ],
  },
  allowedSchemes: [ 'http', 'https', 'mailto', 'tel' ],
  allowedSchemesByTag: {
    img: [ 'http', 'https', 'data' ],
  },
  transformTags: {
    // внешние ссылки: target=_blank + защита от tabnabbing
    a: (tagName, attribs) => ({
      tagName,
      attribs: {
        ...attribs,
        ...(attribs.target === '_blank' && { rel: 'noopener noreferrer' }),
      },
    }),
  },
  allowedStyles: {
    '*': {
      color: [ /^.*$/ ],
      'text-align': [ /^left$|^right$|^center$|^justify$/ ],
      'font-size': [ /^\d+(?:px|em|rem|%)$/ ],
      'background-color': [ /^.*$/ ]
    }
  },
})

Vue.config.productionTip = false

global.BASE_URL = process.env.VUE_APP_BASE_URL
global.SOCKET_URL = process.env.VUE_APP_SOCKET_URL || `https://socket-${window.location.host}`

Vue.prototype.$loader = Vue.observable({
  loaded: false,
  first_loaded: false,
})

const NOTIFICATION_TYPES = [
  'purple',
  'info',
  'success',
  'warning',
  'error'
]

Vue.prototype.$notification = Vue.observable({
  show: false,
  message: '',
  type: 'error',
  types: NOTIFICATION_TYPES
})

Vue.prototype.$showNotification = function(message, type = 'success') {
  this.$notification.show = true
  this.$notification.type = type
  this.$notification.message = message
}

for (const type of NOTIFICATION_TYPES) {
  Vue.prototype[`$show${capitalize(type)}`] = function(message) {
    this.$showNotification(message, type)
  }
}

Vue.prototype.$downloadText = function(text, filename = 'export.csv') {
  const blob = new Blob([text], {type: 'application/octet-stream'});
  const blobURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement('a');
  tempLink.href = blobURL;
  tempLink.setAttribute('download', filename);

  tempLink.click();
  window.URL.revokeObjectURL(blobURL);
}

router.beforeEach((to, from, next) => {
  router.app.$loader.loaded = false
  store.dispatch('auth/checkSession', {}).then((r) => {
    if (to.meta.panel) {
      store.commit('app/setPanel', to.meta.panel)
    }
    if (r.error) {
      try {
        router.app.$notification.show = true
        router.app.$notification.message = get(r.error, 'response.data.message', get(r.error, 'response.message', r.error.toString()))
        router.app.$notification.type = 'error'
      } catch (e) {
      }
    }
    if (!store.state.auth.auth && to.path !== '/login') {
      next(`/login?redirect=${router.app.$route.path}`)
    } else if (store.state.auth.auth && (to.path === '/login' || !store.state.auth.checkAccess(to.meta.access || {}))) {
      next('/')
    } else if (store.state.auth.auth && to.path !== '/verification' && to.path !== '/login' && to.path !== '/logout.json' && !store.state.auth.checkVerification()) {
      next('/verification')
    } else if (store.state.auth.auth && to.path === '/verification' && store.state.auth.checkVerification()) {
      next('/')
    } else {
      next()
    }
  }).finally(() => {
    if (!to.meta.manual_loaded) {
      router.app.$loader.loaded = true
    }
    router.app.$loader.first_loaded = true
  })
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
